module.exports = __webpack_public_path__ + "static/1_seo_page-2b5d2cc84c155ca8fccffefd9d92abe6.webp";